import { UploadImageReadOnlyPlugin } from '../../DolEditor/elements/UploadImage/UploadImageReadOnlyPlugin';
import { UploadVideoReadOnlyPlugin } from '../../DolEditor/elements/UploadVideo/UploadVideoReadOnlyPlugin';
import { UploadAudioReadOnlyPlugin } from '../../DolEditor/elements/UploadAudio/UploadAudioReadOnlyPlugin';
import { UploadFileReadOnlyPlugin } from '../../DolEditor/elements/UploadFile/UploadFileReadOnlyPlugin';
import { ImageSlideShowReadOnlyPlugin } from '../plugins/SpecialObject/ImageSlide/SlideShow/ImageSlideShowReadOnlyPlugin';
import { ImageSlideTextReadOnlyPlugin } from '../plugins/SpecialObject/ImageSlide/SlideText/ImageSlideTextReadOnlyPlugin';
import { VocabListReadOnlyPlugin } from '../../DolEditor/elements/vocab-list/VocabListReadOnlyPlugin';
import { VocabCardReadOnlyPlugin } from '../../DolEditor/elements/vocab-card/VocabCardReadOnlyPlugin';
import { FrameReadOnlyPlugin } from '../../DolEditor/elements/Frame/FrameReadOnlyPlugin';

export const getAllMediaObjectReadOnlyPlugins = ({ isReadOnly }) => [
  // media object
  UploadImageReadOnlyPlugin({ isPreview: isReadOnly }),
  UploadVideoReadOnlyPlugin({ isPreview: isReadOnly }),
  UploadAudioReadOnlyPlugin({ isPreview: isReadOnly }),
  UploadFileReadOnlyPlugin({ isPreview: isReadOnly }),
  ImageSlideShowReadOnlyPlugin({ isReadOnly }), // carousel image
  ImageSlideTextReadOnlyPlugin({ isReadOnly }), // same with slide show but come with text input
  VocabListReadOnlyPlugin({ isPreview: isReadOnly }), // use google sheet to import a vocab list
  VocabCardReadOnlyPlugin({ isPreview: isReadOnly }), // manual input a vocab
  FrameReadOnlyPlugin({ isPreview: isReadOnly }),
];
